import { NavLink } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { STABLECOIN_NETWORKS, coinMeta, sendOnlyCopy } from "../../../features/quick-sell/coinMeta";

/**
 * Network prompt shown when a user taps USDT or USDC on Quick Sell. Tron USDT
 * goes to the existing self-custody page; every other network goes to the
 * generic coin page for that network's coin name.
 */
export const NetworkPicker = ({ coin }: { coin: "usdt" | "usdc" }) => {
  const symbol = coinMeta(coin).symbol;
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-white mb-2">Choose a network for {symbol}</h2>
        <p className="text-sm text-gray-400">
          Pick the network you will send {symbol} from. Each network has its own deposit address.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {STABLECOIN_NETWORKS[coin].map((option) => (
          <NavLink
            key={option.key}
            to={option.selfCustody ? "/app/quick-sell/usdt/tron" : `/app/quick-sell/${option.coin}`}
            className="w-full p-4 rounded-xl bg-gray-800 border border-gray-700 hover:border-primary/50 hover:bg-gray-800/80 transition-all flex items-center justify-between"
          >
            <div className="text-left">
              <p className="text-white font-semibold">{option.label}</p>
              {option.subtitle && <p className="text-xs text-gray-400 mt-1">{option.subtitle}</p>}
            </div>
            <FiChevronRight className="text-gray-400" />
          </NavLink>
        ))}
      </div>
      <p className="text-xs text-gray-400">{sendOnlyCopy(symbol, "the network you choose")}</p>
    </div>
  );
};

export default NetworkPicker;
